import { render, staticRenderFns } from "./qwick_consignmenttrackingmr.vue?vue&type=template&id=62d0bd0a&"
import script from "./qwick_consignmenttrackingmr.vue?vue&type=script&lang=js&"
export * from "./qwick_consignmenttrackingmr.vue?vue&type=script&lang=js&"
import style0 from "./qwick_consignmenttrackingmr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports